/**
 * QuotaResetDialog 组件
 *
 * 配额重置对话框，支持重置单个密钥或全部配额。
 */

import React, { useState } from 'react';
import { searchAdminApi } from '../../../services/searchAdminApi';

interface QuotaResetDialogProps {
  providerName?: string;
  keyIndex?: number;
  onClose: () => void;
  onReset: () => void;
}

export const QuotaResetDialog: React.FC<QuotaResetDialogProps> = ({
  providerName,
  keyIndex,
  onClose,
  onReset,
}) => {
  const [resetting, setResetting] = useState(false);
  const [error, setError] = useState('');

  const handleReset = async (resetAll: boolean) => {
    setResetting(true);
    setError('');
    try {
      await searchAdminApi.resetQuota(undefined, {
        provider_name: resetAll ? undefined : providerName,
        key_index: resetAll ? undefined : keyIndex,
        reset_all: resetAll,
      });
      onReset();
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : '重置配额失败');
    } finally {
      setResetting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-sm p-6 w-full max-w-md">
        <h3 className="text-lg font-medium text-gray-800 mb-4">重置配额</h3>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded text-red-600 text-sm">
            {error}
          </div>
        )}

        <div className="space-y-3">
          {providerName && keyIndex !== undefined && (
            <button
              onClick={() => handleReset(false)}
              disabled={resetting}
              className="w-full px-4 py-2.5 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:opacity-50 text-sm"
            >
              重置 {providerName} / 密钥 #{keyIndex} 的配额
            </button>
          )}
          <button
            onClick={() => handleReset(true)}
            disabled={resetting}
            className="w-full px-4 py-2.5 bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:opacity-50 text-sm"
          >
            重置所有供应商配额
          </button>
          <button
            onClick={() => handleReset(false)}
            disabled={resetting}
            className="w-full px-4 py-2.5 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 disabled:opacity-50 text-sm"
          >
            刷新配额到数据库
          </button>
          <button
            onClick={onClose}
            className="w-full px-4 py-2 bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200 text-sm"
          >
            取消
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuotaResetDialog;
